import { render, staticRenderFns } from "./GradeTable.vue?vue&type=template&id=6d685127&scoped=true&"
import script from "./GradeTable.vue?vue&type=script&lang=js&"
export * from "./GradeTable.vue?vue&type=script&lang=js&"
import style0 from "./GradeTable.vue?vue&type=style&index=0&id=6d685127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d685127",
  null
  
)

export default component.exports